export * from './ArrowALeftIcon';
export * from './ArrowALeftIcon16Light';
export * from './ArrowALeftIcon16Regular';
export * from './ArrowALeftIcon16Solid';
export * from './ArrowALeftIcon20Light';
export * from './ArrowALeftIcon20Regular';
export * from './ArrowALeftIcon20Solid';
export * from './ArrowALeftIcon24Regular';
export * from './ArrowALeftIcon24Solid';
export * from './ArrowALeftIcon32Regular';
export * from './ArrowALeftIcon64Regular';
